import React, { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../../components/Navbar/Navbar";
import PageTitle from "../../components/pagetitle/PageTitle";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import CursorMaus from "../../components/CursorMaus/CursorMaus";
import GlobalTourMap from "../../components/GlobalTourMap/GlobalTourMap";
import Logo from "../../images/logo.webp";
import Phone from "../../images/telephone.svg";

const GlobalTourPage = () => {
  const trips = [
    {
      number: 1,
      title: "MIDDLE EAST LAUNCH",
      duration: "7 Days",
      dates: "12 – 18 November 2025",
      countries: "🇦🇪 UAE • 🇸🇦 Saudi Arabia • 🇶🇦 Qatar",
      cities: "Dubai • Riyadh • Doha",
      focus: "Press launch • NRI entrepreneur meets • GCC chamber tie-ups",
      returnDate: "19 November",
      gap: "11 days",
      color: "#dc2626",
    },
    {
      number: 2,
      title: "SOUTHEAST ASIA EXPANSION",
      duration: "7 Days",
      dates: "30 November – 6 December 2025",
      countries: "🇸🇬 Singapore • 🇲🇾 Malaysia • 🇹🇭 Thailand • 🇻🇳 Vietnam",
      cities: "Singapore • Kuala Lumpur • Bangkok • Ho Chi Minh City",
      focus: "ASEAN partnerships • MSME collaboration • Community onboarding",
      returnDate: "7 December",
      gap: "10 days",
      color: "#c173dd",
    },
    {
      number: 3,
      title: "EAST ASIA & OCEANIA CONNECT",
      duration: "7 Days",
      dates: "18 – 24 December 2025",
      countries: "🇯🇵 Japan • 🇦🇺 Australia",
      cities: "Tokyo • Sydney • Melbourne",
      focus: "Tech & startup collaborations • Oceania Cash Flow Chapter Launch",
      returnDate: "25 December",
      gap: "12 days",
      color: "#f57919",
    },
    {
      number: 4,
      title: "EUROPE LEADERSHIP TOUR",
      duration: "15 Days",
      dates: "6 – 20 January 2026",
      countries:
        "🇬🇧 England • 🇫🇷 France • 🇩🇪 Germany • 🇮🇹 Italy • 🇪🇸 Spain • 🇳🇱 Netherlands",
      cities: "London • Paris • Berlin • Milan • Madrid • Amsterdam",
      focus: "Investor relations • Media interviews • Summit sponsorships",
      returnDate: "21 January",
      gap: "10 days",
      color: "#0fbde7",
    },
    {
      number: 5,
      title: "AFRICA RISING",
      duration: "7 Days",
      dates: "1 – 7 February 2026",
      countries: "🇿🇦 South Africa • 🇰🇪 Kenya • 🇬🇭 Ghana",
      cities: "Johannesburg • Nairobi • Accra",
      focus: "SME collaborations • Africa Chapter launch",
      returnDate: "8 February",
      gap: "9 days",
      color: "#253cf6",
    },
    {
      number: 6,
      title: "AMERICAS GRAND FINALE",
      duration: "15 Days",
      dates: "18 – 28 February 2026",
      countries: "🇺🇸 USA • 🇨🇦 Canada",
      cities: "New York • Los Angeles • Toronto • Vancouver",
      focus: "Global investors • Sponsor finalization • World media coverage",
      returnDate: "28 February 2026 (New Delhi) ✅",
      gap: "",
      color: "#32cd32",
    },
  ];

  return (
    <Fragment>
      <Helmet>
        <title>Global Tour | Cash Flow Summit 2026</title>
        <meta
          name="description"
          content="Discover the Cash Flow Revolution World Tour 2026 route, schedule, countries, and summit expansion plan leading up to Cash Flow Summit 2026."
        />
        <meta
          name="keywords"
          content="Cash Flow Revolution World Tour 2026, Cash Flow Summit global tour, business tour, summit expansion"
        />
        <meta name="author" content="Jagmohan Singh" />
        <meta name="robots" content="index, follow" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      </Helmet>
      <Navbar Logo={Logo} hclass={"wpo-site-header s3"} telephone={Phone} />
      <PageTitle pageTitle={"Global Tour"} pagesub={"Global Tour"} />

      {/* Tour Overview Section */}
      <section className="section-padding" style={{ paddingTop: "60px" }}>
        <div className="container">
          {/* Tour Heading */}
          <div className="row">
            <div className="col-lg-12">
              <div style={{ textAlign: "center", marginBottom: "50px" }}>
                <h2
                  style={{
                    fontSize: "48px",
                    fontWeight: "bold",
                    color: "#2c3e50",
                    marginBottom: "20px",
                  }}
                >
                  CASH FLOW REVOLUTION WORLD TOUR 2026
                </h2>
                <div
                  style={{
                    fontSize: "18px",
                    color: "#2c3e50",
                    lineHeight: "1.8",
                    maxWidth: "1200px",
                    margin: "0 auto",
                  }}
                >
                  <p style={{ marginBottom: "10px" }}>
                    <i className="fa fa-calendar"></i>{" "}
                    <strong>Total Duration:</strong> 12 November 2025 – 28
                    February 2026
                  </p>
                  <p style={{ marginBottom: "10px" }}>
                    <i className="fa fa-globe"></i> <strong>Structure:</strong>{" "}
                    6 Trips | 21 Countries (India + 20)
                  </p>
                  <p style={{ marginBottom: "10px" }}>
                    <i className="fa fa-plane"></i> <strong>Trips:</strong> 4 of
                    7 days + 2 of 15 days | Each starts & ends in India 🇮🇳
                  </p>
                </div>
                <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
                  <div className="award" style={{ position: "static", width: "auto", padding: "15px 20px", transform: "scale(0.85)", left: "auto", bottom: "auto" }}>
                    <div className="icon" style={{ width: "45px", height: "45px" }}>
                      <i className="fa fa-trophy" style={{ color: "white", fontSize: "18px" }}></i>
                    </div>
                    <div className="text">
                      <p style={{ marginBottom: 0, color: "#000B47", fontSize: "15px" }}>
                        <strong>Goal:</strong> Promote Cash Flow Summit 2026 (11 April | Talkatora Stadium, New Delhi)
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <GlobalTourMap />
            </div>
          </div>
        </div>
      </section>

      {/* Trips Detail Section */}
      <section className="section-padding" style={{ background: "#f8f9fa" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h3
                style={{
                  textAlign: "center",
                  fontSize: "36px",
                  fontWeight: "bold",
                  marginBottom: "50px",
                  color: "#2c3e50",
                }}
              >
                <i className="fa fa-map"></i> TOUR ITINERARY
              </h3>
            </div>
          </div>

          <div className="row">
            {trips.map((trip, index) => (
              <div
                key={index}
                className="col-lg-4 col-md-6 col-sm-12"
                style={{ marginBottom: "30px" }}
              >
                <div
                  style={{
                    background: "white",
                    borderRadius: "15px",
                    padding: "0",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
                    overflow: "hidden",
                    height: "100%",
                    position: "relative",
                    transition: "all 0.3s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.boxShadow =
                      "0 15px 40px rgba(0,0,0,0.12)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 10px 30px rgba(0,0,0,0.08)";
                  }}
                >
                  {/* Header with gradient background */}
                  <div
                    style={{
                      background: `linear-gradient(135deg, ${trip.color} 0%, ${trip.color}dd 100%)`,
                      padding: "20px",
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "12px",
                      }}
                    >
                      <div
                        style={{
                          width: "55px",
                          height: "55px",
                          borderRadius: "50%",
                          background: "rgba(255,255,255,0.3)",
                          color: "white",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: "bold",
                          fontSize: "24px",
                          border: "3px solid white",
                        }}
                      >
                        {trip.number}
                      </div>
                    </div>
                    <h4
                      style={{
                        fontSize: "16px",
                        fontWeight: "bold",
                        color: "white",
                        margin: "0",
                        textAlign: "center",
                        lineHeight: "1.4",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                      }}
                    >
                      <i
                        className="fa fa-plane"
                        style={{ marginRight: "8px", fontSize: "18px" }}
                      ></i>
                      {trip.title}
                    </h4>
                    <div
                      style={{
                        textAlign: "center",
                        marginTop: "8px",
                      }}
                    >
                      <span
                        style={{
                          display: "inline-block",
                          fontSize: "11px",
                          color: "white",
                          fontWeight: "600",
                          background: "rgba(255,255,255,0.3)",
                          padding: "4px 12px",
                          borderRadius: "20px",
                        }}
                      >
                        {trip.duration}
                      </span>
                    </div>
                  </div>

                  {/* Content Section */}
                  <div style={{ padding: "20px" }}>
                    <div style={{ marginBottom: "15px" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          marginBottom: "12px",
                        }}
                      >
                        <div
                          style={{
                            minWidth: "32px",
                            width: "32px",
                            height: "32px",
                            borderRadius: "6px",
                            background: `${trip.color}15`,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: "12px",
                            flexShrink: 0,
                          }}
                        >
                          <i
                            className="fa fa-calendar"
                            style={{ color: trip.color, fontSize: "14px" }}
                          ></i>
                        </div>
                        <div style={{ flex: 1 }}>
                          <strong
                            style={{
                              color: "#555",
                              fontSize: "11px",
                              textTransform: "uppercase",
                              letterSpacing: "0.5px",
                              display: "block",
                              marginBottom: "3px",
                            }}
                          >
                            Dates
                          </strong>
                          <p
                            style={{
                              margin: 0,
                              color: "#333",
                              fontSize: "13px",
                              lineHeight: "1.5",
                            }}
                          >
                            {trip.dates}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div style={{ marginBottom: "15px" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          marginBottom: "12px",
                        }}
                      >
                        <div
                          style={{
                            minWidth: "32px",
                            width: "32px",
                            height: "32px",
                            borderRadius: "6px",
                            background: `${trip.color}15`,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: "12px",
                            flexShrink: 0,
                          }}
                        >
                          <i
                            className="fa fa-map-marker"
                            style={{ color: trip.color, fontSize: "14px" }}
                          ></i>
                        </div>
                        <div style={{ flex: 1 }}>
                          <strong
                            style={{
                              color: "#555",
                              fontSize: "11px",
                              textTransform: "uppercase",
                              letterSpacing: "0.5px",
                              display: "block",
                              marginBottom: "3px",
                            }}
                          >
                            Countries
                          </strong>
                          <p
                            style={{
                              margin: 0,
                              color: "#333",
                              fontSize: "13px",
                              lineHeight: "1.5",
                            }}
                          >
                            {trip.countries}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div style={{ marginBottom: "15px" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          marginBottom: "12px",
                        }}
                      >
                        <div
                          style={{
                            minWidth: "32px",
                            width: "32px",
                            height: "32px",
                            borderRadius: "6px",
                            background: `${trip.color}15`,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: "12px",
                            flexShrink: 0,
                          }}
                        >
                          <i
                            className="fa fa-building"
                            style={{ color: trip.color, fontSize: "14px" }}
                          ></i>
                        </div>
                        <div style={{ flex: 1 }}>
                          <strong
                            style={{
                              color: "#555",
                              fontSize: "11px",
                              textTransform: "uppercase",
                              letterSpacing: "0.5px",
                              display: "block",
                              marginBottom: "3px",
                            }}
                          >
                            Cities
                          </strong>
                          <p
                            style={{
                              margin: 0,
                              color: "#333",
                              fontSize: "13px",
                              lineHeight: "1.5",
                            }}
                          >
                            {trip.cities}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div style={{ marginBottom: "15px" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          marginBottom: "12px",
                        }}
                      >
                        <div
                          style={{
                            minWidth: "32px",
                            width: "32px",
                            height: "32px",
                            borderRadius: "6px",
                            background: `${trip.color}15`,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginRight: "12px",
                            flexShrink: 0,
                          }}
                        >
                          <i
                            className="fa fa-bullseye"
                            style={{ color: trip.color, fontSize: "14px" }}
                          ></i>
                        </div>
                        <div style={{ flex: 1 }}>
                          <strong
                            style={{
                              color: "#555",
                              fontSize: "11px",
                              textTransform: "uppercase",
                              letterSpacing: "0.5px",
                              display: "block",
                              marginBottom: "3px",
                            }}
                          >
                            Focus
                          </strong>
                          <p
                            style={{
                              margin: 0,
                              color: "#333",
                              fontSize: "13px",
                              lineHeight: "1.5",
                            }}
                          >
                            {trip.focus}
                          </p>
                        </div>
                      </div>
                    </div>

                    <div
                      style={{
                        borderTop: "1px solid #eee",
                        paddingTop: "15px",
                        marginTop: "10px",
                      }}
                    >
                      <div style={{ marginBottom: "15px" }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            marginBottom: "8px",
                          }}
                        >
                          <div
                            style={{
                              minWidth: "32px",
                              width: "32px",
                              height: "32px",
                              borderRadius: "6px",
                              background: `${trip.color}15`,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              marginRight: "12px",
                              flexShrink: 0,
                            }}
                          >
                            <i
                              className="fa fa-arrow-right"
                              style={{ color: trip.color, fontSize: "14px" }}
                            ></i>
                          </div>
                          <div style={{ flex: 1 }}>
                            <strong
                              style={{
                                color: "#555",
                                fontSize: "11px",
                                textTransform: "uppercase",
                                letterSpacing: "0.5px",
                                display: "block",
                                marginBottom: "3px",
                              }}
                            >
                              Return to India
                            </strong>
                            <p
                              style={{
                                margin: 0,
                                color: "#333",
                                fontSize: "13px",
                                lineHeight: "1.5",
                              }}
                            >
                              {trip.returnDate}
                            </p>
                          </div>
                        </div>
                      </div>

                      {trip.gap && (
                        <div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                            }}
                          >
                            <div
                              style={{
                                minWidth: "32px",
                                width: "32px",
                                height: "32px",
                                borderRadius: "6px",
                                background: `${trip.color}15`,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginRight: "12px",
                                flexShrink: 0,
                              }}
                            >
                              <i
                                className="fa fa-clock-o"
                                style={{ color: trip.color, fontSize: "14px" }}
                              ></i>
                            </div>
                            <div style={{ flex: 1 }}>
                              <strong
                                style={{
                                  color: "#555",
                                  fontSize: "11px",
                                  textTransform: "uppercase",
                                  letterSpacing: "0.5px",
                                  display: "block",
                                  marginBottom: "3px",
                                }}
                              >
                                Gap
                              </strong>
                              <p
                                style={{
                                  margin: 0,
                                  color: "#333",
                                  fontSize: "13px",
                                  lineHeight: "1.5",
                                }}
                              >
                                {trip.gap}
                              </p>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Summary Section */}
      <section className="section-padding" style={{ background: "#f8f9fa" }}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h3
                style={{
                  textAlign: "center",
                  fontSize: "36px",
                  fontWeight: "bold",
                  marginBottom: "20px",
                  color: "#000B47",
                  fontFamily: "'DM Sans', sans-serif",
                }}
              >
                <i className="fa fa-check-circle" style={{ color: "#233FD6", marginRight: "10px" }}></i>
                TOUR STRUCTURE SUMMARY
              </h3>
              <p
                style={{
                  textAlign: "center",
                  color: "#687693",
                  fontSize: "16px",
                  marginBottom: "50px",
                  maxWidth: "700px",
                  margin: "0 auto 50px",
                }}
              >
                A comprehensive overview of our 6-trip global tour spanning 21 countries
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div
                style={{
                  background: "white",
                  borderRadius: "20px",
                  boxShadow: "0px 2px 8px 0px rgba(34, 31, 60, 0.1)",
                  overflow: "hidden",
                }}
              >
                <div style={{ overflowX: "auto" }}>
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                    }}
                  >
                    <thead>
                      <tr
                        style={{
                          background: "#233FD6",
                          color: "white",
                        }}
                      >
                        <th
                          style={{
                            padding: "20px 25px",
                            textAlign: "left",
                            fontFamily: "'DM Sans', sans-serif",
                            fontWeight: "600",
                            fontSize: "14px",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Trip
                        </th>
                        <th
                          style={{
                            padding: "20px 25px",
                            textAlign: "left",
                            fontFamily: "'DM Sans', sans-serif",
                            fontWeight: "600",
                            fontSize: "14px",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Region
                        </th>
                        <th
                          style={{
                            padding: "20px 25px",
                            textAlign: "left",
                            fontFamily: "'DM Sans', sans-serif",
                            fontWeight: "600",
                            fontSize: "14px",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Duration
                        </th>
                        <th
                          style={{
                            padding: "20px 25px",
                            textAlign: "left",
                            fontFamily: "'DM Sans', sans-serif",
                            fontWeight: "600",
                            fontSize: "14px",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Dates
                        </th>
                        <th
                          style={{
                            padding: "20px 25px",
                            textAlign: "left",
                            fontFamily: "'DM Sans', sans-serif",
                            fontWeight: "600",
                            fontSize: "14px",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Countries
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {trips.map((trip, index) => (
                        <tr
                          key={index}
                          style={{
                            borderBottom:
                              index !== trips.length - 1
                                ? "1px solid #e9ecef"
                                : "none",
                            transition: "background 0.2s ease",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.background = "#f8f9fa";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.background = "white";
                          }}
                        >
                          <td
                            style={{
                              padding: "20px 25px",
                            }}
                          >
                            <div
                              style={{
                                width: "40px",
                                height: "40px",
                                borderRadius: "50%",
                                background: trip.color,
                                color: "white",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: "bold",
                                fontSize: "16px",
                                fontFamily: "'DM Sans', sans-serif",
                              }}
                            >
                              {trip.number}
                            </div>
                          </td>
                          <td
                            style={{
                              padding: "20px 25px",
                              color: "#000B47",
                              fontWeight: "600",
                              fontSize: "15px",
                            }}
                          >
                            {trip.title.replace("LAUNCH", "").replace("EXPANSION", "").replace("CONNECT", "").replace("TOUR", "").replace("RISING", "").replace("GRAND FINALE", "").trim()}
                          </td>
                          <td
                            style={{
                              padding: "20px 25px",
                              color: "#687693",
                              fontSize: "14px",
                            }}
                          >
                            {trip.duration}
                          </td>
                          <td
                            style={{
                              padding: "20px 25px",
                              color: "#687693",
                              fontSize: "14px",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {trip.dates}
                          </td>
                          <td
                            style={{
                              padding: "20px 25px",
                              color: "#687693",
                              fontSize: "14px",
                            }}
                          >
                            {trip.countries.replace(/🇦🇪|🇸🇦|🇶🇦|🇸🇬|🇲🇾|🇹🇭|🇻🇳|🇯🇵|🇦🇺|🇬🇧|🇫🇷|🇩🇪|🇮🇹|🇪🇸|🇳🇱|🇿🇦|🇰🇪|🇬🇭|🇺🇸|🇨🇦/g, "").replace(/•/g, ",").trim()}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Total Summary Card */}
                <div
                  style={{
                    background: "#f8f9fa",
                    padding: "30px",
                    marginTop: "0",
                    borderTop: "3px solid #233FD6",
                  }}
                >
                  <div className="row" style={{ textAlign: "center" }}>
                    <div className="col-md-3 col-sm-6" style={{ marginBottom: "20px" }}>
                      <div
                        style={{
                          fontSize: "36px",
                          fontWeight: "bold",
                          color: "#233FD6",
                          fontFamily: "'DM Sans', sans-serif",
                          marginBottom: "5px",
                        }}
                      >
                        6
                      </div>
                      <div
                        style={{
                          fontSize: "14px",
                          color: "#687693",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                      >
                        Total Trips
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-6" style={{ marginBottom: "20px" }}>
                      <div
                        style={{
                          fontSize: "36px",
                          fontWeight: "bold",
                          color: "#233FD6",
                          fontFamily: "'DM Sans', sans-serif",
                          marginBottom: "5px",
                        }}
                      >
                        21
                      </div>
                      <div
                        style={{
                          fontSize: "14px",
                          color: "#687693",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                      >
                        Countries
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-6" style={{ marginBottom: "20px" }}>
                      <div
                        style={{
                          fontSize: "36px",
                          fontWeight: "bold",
                          color: "#233FD6",
                          fontFamily: "'DM Sans', sans-serif",
                          marginBottom: "5px",
                        }}
                      >
                        58
                      </div>
                      <div
                        style={{
                          fontSize: "14px",
                          color: "#687693",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                      >
                        Total Days
                      </div>
                    </div>
                    <div className="col-md-3 col-sm-6" style={{ marginBottom: "20px" }}>
                      <div
                        style={{
                          fontSize: "36px",
                          fontWeight: "bold",
                          color: "#233FD6",
                          fontFamily: "'DM Sans', sans-serif",
                          marginBottom: "5px",
                        }}
                      >
                        24
                      </div>
                      <div
                        style={{
                          fontSize: "14px",
                          color: "#687693",
                          textTransform: "uppercase",
                          letterSpacing: "0.5px",
                        }}
                      >
                        Cities
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <Scrollbar />
      <CursorMaus />
    </Fragment>
  );
};

export default GlobalTourPage;
